import ChevronLeftIcon from "Assets/Icons/ChevronLeftIcon";
import ChevronRightIcon from "Assets/Icons/ChevronRight";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
// import React, { useState } from "react";
import { PaginationLink } from "reactstrap";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const FEPagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  setItemsPerPage,
  setCurrentPage,
  pageLimits,
  pageLimitValue,
  setPageLimitValue,
}: any) => {
  const { control } = useForm();
  const [totalPages, setTotalPages] = useState<any>(
    Math.ceil(totalItems / itemsPerPage)
  );
  const [pages, setPages] = useState<any[]>([]);
  const [pageDefaultValue, setPageDefaultValue] = useState([
    { label: 1, value: 1 },
  ]);
  const { screen }: any = useWindowSize();
  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage));
    setPageDefaultValue([{ label: 1, value: 1 }]);
  }, [totalItems, itemsPerPage]);
  useEffect(() => {
    const arr = [];
    for (let i = 1; i <= totalPages; i++) {
      arr.push({
        label: i,
        value: i,
      });
    }
    setPages(arr);
  }, [totalPages]);

  const handlePageChange = (page: any) => {
    setPageDefaultValue([
      {
        label: page,
        value: page,
      },
    ]);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };
  const handleItemsPerPageChange = (limit: any) => {
    setItemsPerPage(limit?.value);
    setCurrentPage(1); // Reset to the first page when changing items per page
  };
  const handleJumpToPage = (limit: any) => {
    if (limit?.value >= 1 && limit?.value <= totalPages) {
      console.log("limit?.value", limit?.value);
      onPageChange(limit?.value);
    }
  };
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "d-flex justify-content-between align-items-center m-3"
          : "d-flex justify-content-between align-items-center mt-3"
      }
    >
      <div className="d-flex align-items-center">
        <CustomSelect
          disabled={totalItems >= 10 ? false : true}
          width={["xxl", "xl", "lg"].includes(screen) ? "85px" : "60px"}
          value={pageLimitValue}
          onChange={(e: any) => {
            handleItemsPerPageChange(e);
            setPageLimitValue(e);
            console.log("calledLimit2222", e);
            setPageDefaultValue([{ label: 1, value: 1 }]);
          }}
          controlName={control}
          name={"pageLimits"}
          menuPlacement={"top"}
          options={pageLimits}
          infoIcon={true}
          isSearchable={false}
          toolTipData={"Limit of per page"}
        />
        <span className="pl-3 d-flex align-items-center">
          {["xxl", "xl", "lg"].includes(screen)
            ? "Items per page"
            : "items/page"}
        </span>
        {["xxl", "xl", "lg"].includes(screen) && (
          <span className="pl-3 d-flex align-items-center">
            {startItem}-{endItem} of {totalItems} items
          </span>
        )}
      </div>

      <div className="d-flex align-items-center pr-5">
        {currentPage === 1 ? null : (
          <>
            {!["xxl", "xl", "lg"].includes(screen) && (
              <PaginationLink
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeftIcon />
              </PaginationLink>
            )}
          </>
        )}
        <CustomSelect
          disabled={totalItems >= 10 ? false : true}
          width={["xxl", "xl", "lg"].includes(screen) ? "70px" : "50px"}
          value={pageDefaultValue}
          onChange={(e: any) => {
            handleJumpToPage(e);
            setPageDefaultValue(e);
          }}
          controlName={control}
          name={"pages"}
          menuPlacement={"top"}
          options={pages}
          infoIcon={true}
          isSearchable={false}
          toolTipData={"Limit of per page"}
        />
        {["xxl", "xl", "lg"].includes(screen) ? (
          <span className="d-flex align-content-center pl-2">
            of {totalPages} pages
          </span>
        ) : (
          <span className="d-flex align-content-center pl-2">
            /{totalPages}
          </span>
        )}
        {currentPage === 1 ? null : (
          <>
            {["xxl", "xl", "lg"].includes(screen) && (
              <PaginationLink
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeftIcon />
              </PaginationLink>
            )}
          </>
        )}
        {currentPage != totalPages ? (
          <PaginationLink
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <ChevronRightIcon />
          </PaginationLink>
        ) : null}
      </div>
    </div>
  );
};

export default FEPagination;
